export const searchList = [
  { name: '品牌', value: 'brandName' },
  { name: '系列', value: 'seriesName' },
  { name: '型号', value: 'proModel' },
  { name: '订货号', value: 'proOrdernum' },
  { name: '审批特价', value: 'specialPrice' },
  { name: '价格有效期', value: 'specialDate' },
  { name: '是否开启', value: 'flag' },
  { name: '发起人', value: 'createUser' },
  { name: '发起时间', value: 'createDate' }
  // { name: '处理人', value: 'processUser' },
  // { name: '处理日期', value: 'processDate' }
]
// 客户搜索
export const cusNameList = [
  { value: 'cusName', label: '客户名称' },
  // { value: 'useCredit', label: '可用信用' },
  // { value: 'contractTotal', label: '贸易总额' },
  // { value: 'count', label: '签订合同' },
  // { value: 'badDebt', label: '坏帐' },
  { value: 'ccContacts', label: '联系人' },
  { value: 'ccPhone', label: '电话' },
  { value: 'ccMobile', label: '手机' },
  { value: 'cusImplevel', label: '重要等级' }
]
// 账期设置
export const paymentDaySetList = [
  { value: 1, label: '发货后' },
  { value: 2, label: '发货加发票后' },
  { value: 3, label: '开票后' }
]

// 客户详情
export const dataSlect = [
  { value: 1, label: '近一个月' },
  { value: 2, label: '近三个月' },
  { value: 3, label: '近一年' },
  { value: 4, label: '全部' }
]
